










































































































import version from "@/version";
import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"])
})
export default class BankImport extends Vue {
    @Prop()
    period!: string;

    authLink = "暂未生成链接，请先点击左侧按钮";

    message = "获取中";
    isAgree = false;
    isJournal = false;
    isReceipt = false;

    id: number | null = null;
    account = "";
    phone = "";
    agreeDiabled = false;
    defaultUrl = Vue.axios.defaults.baseURL;
    token = this.$store.state.account.token;
    version = version;
    canGet = true;

    async mounted() {
        await this.getBanks();
        await this.fetchDefault();
        await this.init();
    }

    clear() {
        this.account = this.phone = "";
        this.message = "获取中";
        this.isAgree = false;
        this.isJournal = false;
        this.isReceipt = false;
    }

    changeBankType() {
        this.clear();
        this.init();
    }

    async init() {
        await this.fetchData();
        await this.fetchAgree();
    }
    async fetchDefault() {
        const res = await Vue.axios.get(`bank/account/init?accountBookId=${this.$store.state.accountBook.id}`);
        this.bankType = res.data.data;
    }
    async fetchData() {
        const res = await Vue.axios.get(`bank/account/get?accountBookId=${this.$store.state.accountBook.id}&type=${this.bankType}`);
        this.account = res.data.account;
        this.phone = res.data.phone;
        this.id = res.data.id;
    }
    async fetchAgree() {
        if (this.account !== null && this.account.trim() !== "") {
            const res = await Vue.axios.get(`bank/agree/get?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}&type=${this.bankType}`);
            this.message = res.data.message;
            this.isAgree = res.data.data.isAgree;
            this.isJournal = res.data.data.isJournal;
            this.isReceipt = res.data.data.isReceipt;
        }
    }
    async saveBank() {
        const res = await Vue.axios.post("bank/account/save", {
            account: this.account,
            phone: this.phone,
            accountBookId: this.$store.state.accountBook.id,
            id: this.id,
            type: this.bankType
        });
        this.id = res.data.data.id;
    }
    async addAgree() {
        const res = await Vue.axios.post(`bank/agree/add?accountBookId=${this.$store.state.accountBook.id}&type=${this.bankType}`, {});
        this.$utils.sendToElectron("set-clipboard", res.data.data);
        this.$message.success("复制授权链接成功");
        this.agreeDiabled = true;
    }
    async getJournalData() {
        const res = await Vue.axios.post(`bank/data/get?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}&type=${this.bankType}`, { a: 1 });
        this.$notify({
            type: "success",
            title: res.data.message,
            message: res.data.data,
            duration: 5000
        });
        this.canGet = false;
        this.fetchAgree();
    }

    /**
     * 打开链接
     */
    openHref(url: string) {
        window.open(url, "_self");
    }

    /** 
     * 导入流水 
     * */
    async importBank() {
        const res = await Vue.axios.post(`bank/journals/import?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}&openingBank=${this.openingBank}&type=${this.bankType}`, {
            a: 1
        });
        this.openBankVisible = false;
        this.$notify({
            type: "success",
            title: res.data.message,
            message: res.data.data
        });
    }

    // 开户行改为可自定义新增的下拉框
    openBankVisible = false;
    openingBank: string = "";
    banks: string[] = [];
    async getBanks() {
        const res = await Vue.axios.post(`journals/openingbanks?accountBookId=${this.$store.state.accountBook.id}`);
        Object.keys(res.data.openingBanks).forEach(e => {
            this.banks.push(e);
        });
        if (this.banks.length > 0) this.openingBank = this.banks[0];
        else this.openingBank = "";
    }
    // 开户行失去焦点
    blurBank(e: any) {
        this.openingBank = e.target.value;
    }
    close() {
        this.$emit("close");
    }

    bankTypeList = [
        {
            type: 0,
            text: "工商银行",
            disabled: false
        },
        {
            type: 2,
            text: "交通银行",
            disabled: false
        },
        {
            type: 1,
            text: "平安银行",
            disabled: false
        }
    ];
    bankType = 0;
}
